export default __webpack_public_path__ + "static/1640-c1afdb13b6b6ac32c48b479524c4cca3.gif";